import { shallowEqual, useSelector } from 'react-redux';

import Carousel from '@/components/organisms/Dialogs/Action/Carousel/Carousel';
import AIResponseActionCard from '@/components/organisms/Dialogs/Action/SubAgent/AIResponseActionCard';
import AuthActionCard from '@/components/organisms/Dialogs/Action/SubAgent/AuthActionCard';
import { selectActions } from '@/redux/dialogs/selectors';
import { RootState } from '@/shared/types/state';

import Action from './Action/Action';

type Props = { nodeId: string; conditionIndex?: number; requisiteIndex?: number };

const ActionList = ({ nodeId, conditionIndex = null, requisiteIndex = null }: Props) => {
  const actions = useSelector(
    (state: RootState) => selectActions(state, { nodeId, conditionIndex, requisiteIndex }),
    shallowEqual
  );

  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <>
      {actions.map((action, actionIndex) => {
        if (action.type === 'carousel') {
          return (
            <Carousel
              key={action.action_id}
              nodeId={nodeId}
              actionId={action.action_id}
              action={action}
              conditionIndex={conditionIndex}
              requisiteIndex={requisiteIndex}
              actionIndex={actionIndex}
            />
          );
        }
        if (action.type === 'sub_agent') {
          if (action.sub_agent_config?.type === 'ai_response') {
            return (
              <AIResponseActionCard
                key={action.action_id}
                nodeId={nodeId}
                actionId={action.action_id}
                action={action}
                conditionIndex={conditionIndex}
                requisiteIndex={requisiteIndex}
              />
            );
          }
          return (
            <AuthActionCard
              key={action.action_id}
              nodeId={nodeId}
              actionId={action.action_id}
              action={action}
              conditionIndex={conditionIndex}
              requisiteIndex={requisiteIndex}
            />
          );
        }
        return (
          <Action
            key={action.action_id}
            nodeId={nodeId}
            actionId={action.action_id}
            action={action}
            conditionIndex={conditionIndex}
            requisiteIndex={requisiteIndex}
            actionIndex={actionIndex}
          />
        );
      })}
    </>
  );
};

export default ActionList;
